<!-- Loading state -->
<div class="simulation-detail" *ngIf="isLoading || isError">
  <div *ngIf="isLoading" class="centered-div">
    <qai-loading size="medium"></qai-loading>
  </div>

  <!-- Error state -->
  <div *ngIf="!isLoading && isError" class="centered-div error-container">
    <h3>Simulation not found.</h3>
  </div>
</div>

<!-- Main content -->
<div *ngIf="!isLoading && !isError">
  <div class="simulation-detail" *ngIf="isTranslationLoaded">
    <qai-inner-wrap>
      <qai-breadcrumb-list [items]="getBreadcrumbItems()"></qai-breadcrumb-list>
      <span class="simulation-heading">{{ simulationName }}</span>

      <div class="simulation-team-selector" *ngIf="teamOptions.length > 1">
        <qai-label class="selector-label" kind="secondary" size="small" weight="bold">
          {{ 'reportingV2.TEAMS' | transloco }}
        </qai-label>

        <qai-multiselect
          [options]="teamOptions"
          [placeholder]="isLoadingTeams
            ? ('reportingV2.LOADING_TEAMS' | transloco)
            : ('reportingV2.SEARCH_TEAMS' | transloco)"
          [placement]="'below-start'"
          [offset]="4"
          [startIcon]="'search'"
          [value]="selectedTeamUuids"
          (valueChange)="onTeamChange($event)"
          [clearButton]="clearTeamsOption"
          [selectionDisplayMode]="'single-row-truncated'"
          [visibleOptionsSelectionMode]="visibleOptionsMode"
          [persistSearch]="true"
        ></qai-multiselect>
      </div>
    </qai-inner-wrap>
  </div>

  <qai-inner-wrap>

    <ng-container *ngIf="!isDataLoading; else dataLoading">
      <qai-flex-container
        [direction]="'row'"
        [justifyContent]="'flex-start'"
        [flexWrap]="'wrap'"
        [background]="'transparent'"
        [gap]="'var(--spacing-3xl)'"
        [alignItems]="'normal'"
        [border]="false"
      >
        @if (shouldShowMethodologyAverages) {
          <app-methodology-averages
            [moduleAssignmentUuid]="moduleAssignmentUuid"
            [simulationUuid]="simulationUuid ?? ''"
            [accountUuid]="accountUuid"
            [teamUuids]="selectedTeamUuids"
          />
        }
        
        @if (shouldShowMessagingAverages) {
          <app-messaging-averages
            [moduleAssignmentUuid]="moduleAssignmentUuid"
            [simulationUuid]="simulationUuid ?? ''"
            [accountUuid]="accountUuid"
            [teamUuids]="selectedTeamUuids"
            [promptType]="promptType"
          />
        }
        
        @if (shouldShowSkillsAverages) {
          <app-skills-averages
            [moduleAssignmentUuid]="moduleAssignmentUuid"
            [simulationUuid]="simulationUuid ?? ''"
            [accountUuid]="accountUuid"
            [teamUuids]="selectedTeamUuids"
          />
        }
      
      </qai-flex-container>
      <app-simulation-sessions
        [totalSessionsCount]="sessionStats.length"
        [sessionStats]="sessionStats"
      >
      </app-simulation-sessions>
    </ng-container>

    <ng-template #dataLoading>
      <div class="centered-div">
        <qai-loading size="medium"></qai-loading>
      </div>
    </ng-template>
  </qai-inner-wrap>
</div>
